<template>
  <div class="dropdown-select" :tabindex="tabindex" :style="`width: ${width}`" @blur="show = false">
    <span @click="show = !show" style="width: 100%;">
      <div :class="classBody" style="width: calc(100% - 30px); display: flex; align-items: center;">
          <span style="width: 90%">{{labelFieldName === null ? selected : selected[labelFieldName]}}</span>
          <span style="text-align: end; width: 10%; color:#77A0D6"><i class="fas fa-angle-down"></i></span>
       </div>
    </span>
    <div class="dropdown-select-content-custom" :style="`width: ${widthOptions}`" :class="{ showOptions: !show }">
      <a v-for="(item, index) in items" :key="index" @click="chose(item)">
        {{ labelFieldName === null ? item : item[labelFieldName] }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "selectDropdown",
  props: {
    items: {
      type: Array,
      required: true
    },
    keyFieldName: {
      type: String,
      default: null
    },
    labelFieldName: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    classBody: {
      type: String,
      default: 'dropdown-select-body'
    },
    width:{
      type: String,
      default: '100%'
    },
    returnFieldName:{
      type: String,
      default: null
    },
    defaultValue: {
      required: false,
      default: null
    },
    widthOptions: {
      type: String,
      default: `100%`
    }
  },
  emits: ['saveData'],
  data() {
    return {
      show: false,
      selected: this.defaultValue !== null ?
          this.keyFieldName !== null ? this.items.find(x => x[this.keyFieldName] === this.defaultValue) : this.defaultValue :
          this.items.length > 0 ? this.items[0] : null
    }
  },
  methods: {
    chose(option) {
      this.show = false;
      this.selected = option;
      this.$emit('saveData', this.returnFieldName === null ? option : option[this.returnFieldName]);
    }
  }
}
</script>

<style lang="scss">
.dropdown-select {
  position: relative;
  display: inline-block;
}

.dropdown-select-content-custom {
  position: absolute;
  background-color: var(--select-dropdown-background);
  z-index: 1;
  padding: 10px 0;
  font-size: 15px;
  font-weight: 400;
  border-radius: 5px;
  color: var(--select-dropdown-text);
  text-align: start;
  box-shadow: 0 4px 24px 0 var(--dropdown-shadow);
  max-height: 300px;
  overflow-y: auto;
}

.dropdown-select-content-custom::-webkit-scrollbar {
  width: 0;
}

.dropdown-select-content-custom a {
  color: var(--select-dropdown-text);
  padding: 9px 20px;
  text-decoration: none;
  display: block;
}

.dropdown-select-content-custom a:hover {
  background-color: var(--select-dropdown-background-hover);
}

/*.dropdown-select:hover .dropdown-select-content-custom{
  display: block;
}*/
.dropdown-select-content-custom.showOptions {
  display: none;
}


.dropdown-select .dropdown-select-body{
  background: var(--input-background);
  border-radius: 5px;
  height: 40px;
  width: 100%;
  padding: 0 15px;
  border: none;
  outline: none;
  color: var(--select-dropdown-text);
  margin-bottom: 25px;
}
</style>
